import { Box, FormControl, InputLabel, Typography, useTheme } from '@mui/material';
import { PrimaryButton, StyledOutlinedInput, TextButton } from 'components/atoms';
import React, { ChangeEvent, useState } from 'react';

import { MultiFactorAuthProps } from './types';

export const MultiFactorAuth = ({ auth, onSubmit }: MultiFactorAuthProps) => {
  const theme = useTheme();
  const [mfaCode, setMfaCode] = useState('');

  const handleCodeChange = ({
    target: { value: newValue },
  }: ChangeEvent<HTMLInputElement>) => {
    setMfaCode(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant="body1" sx={{ marginY: '15px' }}>
        An authentication code has been sent to your email address.
      </Typography>
      <FormControl required={true} style={{ width: '100%', marginBottom: '10px' }}>
        <StyledOutlinedInput onChange={handleCodeChange} />
        <InputLabel sx={{ background: theme.palette.background.paper }}>
          Authentication Code
        </InputLabel>
      </FormControl>
      <PrimaryButton
        aria-label="submit"
        disabled={mfaCode.length == 0}
        onClick={() => onSubmit(auth, mfaCode)}
        sx={{ marginBottom: '10px', width: '100%' }}
      >
        Submit
      </PrimaryButton>
      <TextButton onClick={history.back} sx={{ width: '100%' }}>
        RETURN TO SIGN IN
      </TextButton>
    </Box>
  );
};
